import {
  constants as appStorageConstants,
  records as appStorageRecords,
} from '@saucelabs/sl-module-app-storage';

import { TabKind, TabPath } from './components/MobileAppSelection';
import { CONFIGURATION_MOBILE_APP_TAB_URL_PATHS } from '../../constants';
import constants from './constants';

const buildAppVersionString = (appBuild: appStorageRecords.AppStorageFile): string => {
  const versionNumber = appBuild.getVersion();
  const buildNumber = appBuild.getBuild();

  if (!buildNumber) {
    return versionNumber ? `v${versionNumber}` : '';
  }
  return `${versionNumber ? `v${versionNumber}, ` : ''}Build ${buildNumber}`;
};

const buildAppInfoString = (appStorageFile: appStorageRecords.AppStorageFile | null): string => {
  if (!appStorageFile) {
    return '';
  }

  const appName = appStorageFile.getDisplayName();
  const appVersionString = buildAppVersionString(appStorageFile);

  return appVersionString ? `${appName} (${appVersionString})` : appName;
};

const getUrlForMobileSelection = (
  file: appStorageRecords.AppStorageFile | null,
  currentTabPath: TabPath,
  requestedTab?: TabKind,
): string => {
  const { MOBILE_VIRTUAL, MOBILE_REAL } = CONFIGURATION_MOBILE_APP_TAB_URL_PATHS;
  const isSimulatorBuild = file?.isSimulatorBuild();
  const isAndroid = file?.kind === appStorageConstants.APP_STORAGE_KIND.ANDROID;
  const requestedTabPath = CONFIGURATION_MOBILE_APP_TAB_URL_PATHS[requestedTab ?? 0] as string;

  let defaultTabPath = isSimulatorBuild ? MOBILE_VIRTUAL : MOBILE_REAL;

  // stay on the currently selected tab
  if (isAndroid && currentTabPath) {
    defaultTabPath = currentTabPath;
  }

  if (!file) {
    return `${constants.BASE_URL}/${requestedTabPath ?? currentTabPath ?? defaultTabPath}`;
  }

  return `${constants.BASE_URL}/file/${file.id}/${requestedTab ? requestedTabPath : defaultTabPath}`;
};

export default {
  buildAppInfoString,
  buildAppVersionString,
  getUrlForMobileSelection,
};
